import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./Login.css";
import { config } from "../../confi";
import auth from "../../service";

const Login = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [Error, setError] = useState("");
  const [Msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  useEffect(() => {
    
    if (auth.getAuth()) {
      history.push("/admin");
    }
  }, [history]);

  ///////
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (email === "" || password === "") {
      setError("please provide credentials");

      return;
    }
    const data = JSON.stringify({ email: email, password: password });

    try {
      const response = await fetch(`${config.apiBaseURL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      });

      let res_data = await response.json();
   

      if (res_data.status === "0") {
        auth.setAuth(res_data.token);
        history.push("/admin/member");
      }

      if (res_data.status === "1") {
        setError(res_data.msg);
      }
    } catch (error) {
      setError("please try again");
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2> Admin Login</h2>
        <input
          className="login-input"
          type="text"
          placeholder="Email"
          value={email}
          onChange={handleEmailChange}
        />
        <input
          className="login-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={handlePasswordChange}
        />
        <button className="login-button" type="submit">
          Login
        </button>
        {Error ? <p className="error-msg">{Error}</p> : <></>}
      </form>
    </div>
  );
};

export default Login;
